import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=6f4bd00e&scoped=true&"
import script from "./Popover.vue?vue&type=script&lang=js&"
export * from "./Popover.vue?vue&type=script&lang=js&"
import style0 from "./Popover.vue?vue&type=style&index=0&id=6f4bd00e&scoped=true&lang=css&"
import style1 from "./Popover.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4bd00e",
  null
  
)

export default component.exports